import script from "./ManagePlanDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagePlanDialog.vue?vue&type=script&setup=true&lang=js"

import "./ManagePlanDialog.vue?vue&type=style&index=0&id=365c7952&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-365c7952"]])

export default __exports__